import React from "react";
// import avitar from "../avitar.png"   you can import or use require
import "../about.css"


export default function Home() {
  return (
    <div className="about">
      <div ><img className="avitarA" src={require('../images/avitar.jpg')} alt="pic"/> 
       
      <p className="title-about">
        Hello. I am Jay Tranberg. <br></br>
        I am a WEB3, APP/DAPP, Blockchain developer.<br></br>
        Developing for over 7 years.<br></br>
        Working the Blockchain environments for 6+ years.<br></br>
        Languges and multiple framworks and libraries.<br></br>

        I HUNT BUGS IN CODE!!! Nothing more satisfying than hunting Bugs in code.

        </p> 
        </div>
       <br></br>
  
    </div>
  );
}